import React from "react";
import { useLocation } from "react-router-dom";
import Routing from "./routes/Routing";
import { ToastContainer } from "react-toastify";

import { UserProvider } from "./utils/UserProvider";
import { ToastProvider } from "./utils/ToastProvider";
import { Toaster } from "./core-ui/toaster/Toaster";
import { HelmetProvider } from "react-helmet-async";

const App = () => {
  const location = useLocation();
  const originalUrl =
    window.location.origin +
    location.pathname +
    location.search +
    location.hash;

  return (
    <HelmetProvider>
      <ToastProvider>
        <UserProvider>
          <Routing originalUrl={originalUrl} />
          <Toaster />
          <ToastContainer />
        </UserProvider>
      </ToastProvider>
    </HelmetProvider>
  );
};

export default App;
